function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 256c0-24 16-43 36-43h440c20 0 36 19 36 43s-16 43-36 43H36c-20 0-36-19-36-43z"
});

function SvgDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dash_svg__icon",
    viewBox: "0 0 512 512",
    height: "1em",
    width: "1em",
    fill: "currentColor"
  }, props), _ref);
}

export default __webpack_public_path__ + "dash-c17b7929a6fdc96967a6dce9484df97c.svg";
export { SvgDash as ReactComponent };